import React, { useContext } from 'react';
import { atratoColor } from '../../../../../../assets/images/Global';
import styles from '../../MethodsFlow.module.css';
import data from '../../data';
import PaymentContext from '../../../../../../context/Payment/Context';
import AtratoPayment from '../../../../../AtratoPayment';

const FlowAtrato = () => {
  const paymentContext = useContext(PaymentContext);
  const { hasAddress } = paymentContext;
  const {
    titleAtrato, descriptionAtrato,
  } = data.atrato;

  React.useEffect(() => {
    const event = new Event('DOMContentLoaded');
    document.dispatchEvent(event);
  }, []);

  return (
    <>
      <div className={styles.container}>
        <p className={styles.title}>{titleAtrato}</p>
        <p className={styles.text}>{descriptionAtrato}</p>
        <img
          className={styles.logo}
          width={66}
          height={24}
          src={atratoColor}
          alt="Atrato Logo"
        />
      </div>
      <div className={styles.button}>
        {!hasAddress && (
          <p className={styles.textPreventAddress}>
            Agrega una dirección de envío para continuar.
          </p>
        )}
        <AtratoPayment />
      </div>
    </>
  );
};

export default FlowAtrato;
